/**
 * Build-time configuration, injected from Terraform outputs.
 *
 * These are all public values — a Cognito client id and issuer are not secrets,
 * since the SPA uses PKCE and holds no client secret. Security comes from the
 * user pool and the API Gateway authorizer, not from hiding these.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    // Failing loudly at startup beats a blank screen and a confusing OIDC error
    // three redirects later.
    throw new Error(
      `Missing ${name}. The admin app must be built with the VITE_* variables from \`terraform output\`.`,
    );
  }
  return value;
}

export const config = {
  apiUrl: required("VITE_API_URL", import.meta.env["VITE_API_URL"]),
  authority: required("VITE_COGNITO_AUTHORITY", import.meta.env["VITE_COGNITO_AUTHORITY"]),
  clientId: required("VITE_COGNITO_CLIENT_ID", import.meta.env["VITE_COGNITO_CLIENT_ID"]),
  /** Hosted UI base, needed for logout — it isn't part of OIDC discovery. */
  hostedUi: required("VITE_COGNITO_HOSTED_UI", import.meta.env["VITE_COGNITO_HOSTED_UI"]),
};

/** Derived at runtime so the same bundle works on localhost and on admin.*. */
export const redirectUri = `${window.location.origin}/`;

/**
 * Contact details used when drafting recruiting ads.
 *
 * These duplicate `apps/site/src/config.ts`, which is the marketing source of
 * truth -- the admin can't import from the site app. Drafted ad copy is editable
 * before it is posted, so a stale value here is a visible typo rather than a
 * silent wrong number, but keep them in step.
 */
export const businessContact = {
  phone: "(705) 571-1319",
  applyUrl: "https://huntscleaning.ca/work-with-us",
};
